<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { usePageStore } from '../../stores/page'
import { useImgSrcSet } from '../../composables/use-img-src-set'
import { useCdnImages } from '../../composables/use-cdn-images'

const props = withDefaults(defineProps<{
  type?: 'badge' | 'button'
}>(), {
  type: 'button'
})

const { createImgSrc } = useImgSrcSet()
const { cdnImageUrl } = useCdnImages()

const { pageData, brandFromStore } = storeToRefs(usePageStore())

const leadArticleImgSource = computed(() => createImgSrc({
  image: pageData.value?.metaData?.ogImage || {},
  brand: brandFromStore.value
}))

const buttonStyles = computed(() => props.type === 'button' ? 'bx-social-share__element--pinterest' : 'bx-badge bx-badge--pinterest')

const buttonLink = computed(() => {
  const pageMeta = pageData.value?.pageMeta
  const metaData = pageData.value?.metaData
  return `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(`${pageMeta?.baseUrl ?? ''}${pageMeta?.url ?? ''}`)}&media=${encodeURIComponent(leadArticleImgSource.value ?? '')}&description=${encodeURIComponent(metaData?.metaTitle ?? '')}`
})

const openCreatePin = () => {
  window.open(buttonLink.value, '_blank')
}
</script>

<template>
  <a :class="buttonStyles"
     :data-href="buttonLink"
     target="_blank"
     rel="nofollow noopener"
     tabindex="0"
     @click="openCreatePin()">
    <img v-if="type === 'badge'"
         :src="cdnImageUrl('/images/shared/pinterest.svg')"
         width="34"
         height="34"
         loading="lazy"
         alt="Auf Pinterest merken">
    <span v-else
          class="icon icon--social-share icon-pinterest">
      <svg><use href="#pinterest" /></svg>
      <span class="bx-social-share__text">Teilen</span>
    </span>
  </a>
</template>
